export const signatureStepEnum = Object.freeze({
  SUBSCRIPTION: 'SUBSCRIPTION',
  ADVICE: 'ADVICE'
});
